import { FC, ImgHTMLAttributes, useEffect, useState } from 'react';
import { of } from 'rxjs';
import { useService } from '@hooks';
import { CarModel, carModelService } from '@services';
import { Box, BoxProps } from '@mui/material';
import fallbackVehicleLogo from '@assets/illustrations/default-vehicle.png';

export interface IVehicleImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
	model?: CarModel;
	containerProps?: BoxProps;
}

export const VehicleImage: FC<IVehicleImageProps> = ({ model, containerProps, style, ...props }) => {
	const [image, setImage] = useState(fallbackVehicleLogo);
	const { data: loadedImage } = useService(() => (model ? carModelService.getImage(model.brand, model.model) : of(undefined)), [model]);
	useEffect(() => {
		loadedImage && setImage(loadedImage);
	}, [loadedImage]);

	return (
		<Box display="flex" alignItems="center" justifyContent="center" {...containerProps}>
			<img
				style={{ width: 'auto', height: 60, maxWidth: '100%', ...style }}
				{...props}
				src={image}
				onError={(ev) => ((ev.target as HTMLImageElement).src = fallbackVehicleLogo)}
			/>
		</Box>
	);
};
